import { render, staticRenderFns } from "./DashboardGrupoRepasse.vue?vue&type=template&id=25428462&scoped=true"
import script from "./DashboardGrupoRepasse.vue?vue&type=script&lang=ts"
export * from "./DashboardGrupoRepasse.vue?vue&type=script&lang=ts"
import style0 from "./DashboardGrupoRepasse.vue?vue&type=style&index=0&id=25428462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25428462",
  null
  
)

export default component.exports